export const enUSCategories = {
  loading: 'Loading categories...',
  errorLoad: 'Failed to load categories. Please try again.',
  pageTitle: 'Categories',
  addCategory: 'Add Category',
  noCategories: 'No categories yet. Create your first category.',
  modalCreateTitle: 'Create Category',
  modalEditTitle: 'Edit Category',
  deleteTitle: 'Delete Category',
  deleteMessage: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
  deleteConfirm: 'Delete',
  childCategoryLabel: '(under {{name}})',
  formNameLabel: 'Name',
  formNamePlaceholder: 'e.g., Groceries',
  formColorLabel: 'Color (optional)',
  formColorPlaceholder: '#FF5733',
  formParentLabel: 'Parent Category (optional)',
  formParentNone: 'None (Top-level category)',
  formSaving: 'Saving...',
  formCreating: 'Creating...',
  formSave: 'Save',
  formCreate: 'Create',
  formError: 'Failed to save category',
  validationNameRequired: 'Name is required',
  validationNameTooLong: 'Name is too long',
  validationColorInvalid: 'Color must be a valid hex color (e.g., #FF5733)',
  noCategoriesTitle: 'No categories',
  noCategoriesMessage: 'Create categories to organize your expenses and bills.',
} as const;
